module.exports = __webpack_public_path__ + "static/media/failedpayment.32573458.svg";